module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "content"
  }, [(_vm.row.danwei.registstatus == 0) ? _c('div', {
    staticClass: "danwei_not"
  }, [_c('h1', [_vm._v("单位认证")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    directives: [{
      name: "rblink",
      rawName: "v-rblink",
      value: ({
        name: 'CertDanwei'
      }),
      expression: "{ name: 'CertDanwei' }"
    }],
    staticClass: "goDanwei"
  }, [_vm._v("立即认证")])]) : _vm._e(), _vm._v(" "), (_vm.row.danwei.registstatus != 0) ? _c('div', {
    staticClass: "danwei"
  }, [_c('h1', [_vm._v(_vm._s(_vm.row.danwei.name))]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "br"
  }), _vm._v(" "), _c('van-cell-group', [_c('van-field', {
    directives: [{
      name: "rblink",
      rawName: "v-rblink",
      value: ({
        name: 'YundongyuanList'
      }),
      expression: "{ name: 'YundongyuanList' }"
    }],
    attrs: {
      "value": "",
      "label": "运动员管理",
      "label-width": "150",
      "is-link": "",
      "input-align": "right",
      "readonly": ""
    }
  }), _vm._v(" "), _c('van-field', {
    directives: [{
      name: "rblink",
      rawName: "v-rblink",
      value: ({
        name: 'CaipanList'
      }),
      expression: "{ name: 'CaipanList' }"
    }],
    attrs: {
      "value": "",
      "label": "随队裁判员管理",
      "label-width": "150",
      "is-link": "",
      "input-align": "right",
      "readonly": ""
    }
  }), _vm._v(" "), _c('van-field', {
    directives: [{
      name: "rblink",
      rawName: "v-rblink",
      value: ({
        name: 'JiaolianList'
      }),
      expression: "{ name: 'JiaolianList' }"
    }],
    attrs: {
      "value": "",
      "label": "随队教练员管理",
      "label-width": "150",
      "is-link": "",
      "input-align": "right",
      "readonly": ""
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "flex"
    }
  }, [(_vm.row.danwei.registstatus == 2) ? _c('div', {
    staticClass: "delete_danwei",
    staticStyle: {
      "margin-top": "0"
    },
    on: {
      "click": _vm.unbind
    }
  }, [_vm._v("\n          解除认证\n        ")]) : _vm._e(), _vm._v(" "), (_vm.row.danwei_list.length > 1) ? _c('div', {
    staticClass: "goDanwei",
    staticStyle: {
      "margin-top": "0"
    },
    on: {
      "click": function($event) {
        _vm.sheetActiveShow = true
      }
    }
  }, [_vm._v("\n          更换单位\n        ")]) : _vm._e(), _vm._v(" "), (_vm.row.danwei_list.length > 0) ? _c('div', {
    directives: [{
      name: "rblink",
      rawName: "v-rblink",
      value: ({
        name: 'CertDanwei',
        query: {
          new: 1
        }
      }),
      expression: "{ name: 'CertDanwei',query:{new:1} }"
    }],
    staticClass: "goDanwei",
    staticStyle: {
      "margin-top": "0",
      "margin-left": "10px"
    }
  }, [_vm._v("\n          新增认证\n        ")]) : _vm._e()])], 1) : _vm._e(), _vm._v(" "), (_vm.row.cert.status == 0) ? _c('div', {
    staticClass: "num_not"
  }, [_c('h1', [_vm._v("实名认证")]), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "goNum",
    on: {
      "click": function($event) {
        _vm.showNumTypePicker = true
      }
    }
  }, [_vm._v("立即认证")])]) : _vm._e(), _vm._v(" "), (_vm.row.cert.status == 1) ? _c('div', {
    staticClass: "num"
  }, [_c('h1', [_vm._v(_vm._s(_vm.row.cert.user_name) + "-" + _vm._s(_vm.row.cert.user_code))]), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "delete_danwei",
    on: {
      "click": _vm.unbindPerson
    }
  }, [_vm._v("解除认证")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "manage"
  }, [_c('h1', [_vm._v("证件照管理")]), _vm._v(" "), _c('h2', [_vm._v("裁判员、教练员等证书照片显示")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "rblink",
      rawName: "v-rblink",
      value: ({
        name: 'CertPersonPhoto'
      }),
      expression: "{ name: 'CertPersonPhoto' }"
    }],
    staticClass: "goNum"
  }, [_vm._v("去管理")])]), _vm._v(" "), (_vm.row.weiyuanhui_list.length > 0) ? _c('div', {
    staticClass: "manage"
  }, [_c('h1', [_vm._v("省市管理")]), _vm._v(" "), _c('h2', [_vm._v("管理赛事、会议、七彩星级、俱乐部、大课间等信息")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "rblink",
      rawName: "v-rblink",
      value: ({
        name: 'WeiyuanhuiList'
      }),
      expression: "{ name: 'WeiyuanhuiList' }"
    }],
    staticClass: "goNum"
  }, [_vm._v("去选择")])]) : _vm._e(), _vm._v(" "), (_vm.row.wa_fl) ? _c('div', {
    staticClass: "manage"
  }, [_c('h1', [_vm._v("区域合伙人管理")]), _vm._v(" "), _c('h2', [_vm._v("个人在所在区域内所有销售业务管理")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "rblink",
      rawName: "v-rblink",
      value: ({
        name: 'WyhConfigureList'
      }),
      expression: "{ name: 'WyhConfigureList' }"
    }],
    staticClass: "goNum"
  }, [_vm._v("去管理")])]) : _vm._e(), _vm._v(" "), (_vm.row.pa_fl) ? _c('div', {
    staticClass: "manage"
  }, [_c('h1', [_vm._v("个人合伙人管理")]), _vm._v(" "), _c('h2', [_vm._v("个人所有销售业务管理")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "rblink",
      rawName: "v-rblink",
      value: ({
        name: 'ConfigureList'
      }),
      expression: "{ name: 'ConfigureList' }"
    }],
    staticClass: "goNum"
  }, [_vm._v("去管理")])]) : _vm._e(), _vm._v(" "), (_vm.row.fa_fl) ? _c('div', {
    staticClass: "manage"
  }, [_c('h1', [_vm._v("省服务专员")]), _vm._v(" "), _c('h2', [_vm._v("所联络的省份的所有销售订单管理")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "rblink",
      rawName: "v-rblink",
      value: ({
        name: 'WyhConfigureList'
      }),
      expression: "{ name: 'WyhConfigureList' }"
    }],
    staticClass: "goNum"
  }, [_vm._v("管理订单")])]) : _vm._e(), _vm._v(" "), (_vm.row.user_fl) ? _c('div', {
    staticClass: "manage"
  }, [_c('h1', [_vm._v("公司内部管理")]), _vm._v(" "), _c('h2', [_vm._v("CCA公司内部业务管理：销售订单管理，推荐订单管理")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "rblink",
      rawName: "v-rblink",
      value: ({
        name: 'ConfigureList'
      }),
      expression: "{ name: 'ConfigureList' }"
    }],
    staticClass: "goNum"
  }, [_vm._v("去管理")])]) : _vm._e()]), _vm._v(" "), _c('van-popup', {
    attrs: {
      "position": "bottom"
    },
    model: {
      value: (_vm.showNumTypePicker),
      callback: function($$v) {
        _vm.showNumTypePicker = $$v
      },
      expression: "showNumTypePicker"
    }
  }, [_c('van-picker', {
    attrs: {
      "columns": _vm.numTypeColumns,
      "show-toolbar": "",
      "title": "实名验证类型选择"
    },
    on: {
      "cancel": function($event) {
        _vm.showNumTypePicker = false
      },
      "confirm": _vm.onNumTypeConfirm
    }
  })], 1), _vm._v(" "), _c('van-action-sheet', {
    attrs: {
      "description": "将以新的单位为主体参赛报名",
      "actions": _vm.row.danwei_list,
      "cancel-text": "取消",
      "close-on-click-action": ""
    },
    on: {
      "cancel": _vm.onSheetCancel,
      "select": _vm.onSelect
    },
    model: {
      value: (_vm.sheetActiveShow),
      callback: function($$v) {
        _vm.sheetActiveShow = $$v
      },
      expression: "sheetActiveShow"
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h2', [_vm._v("关联CCA单位信息，完成后可获得单位相关业务 "), _c('br'), _vm._v("权限")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h2', [_vm._v("关联CCA单位信息，完成后可获得单位相关业务 "), _c('br'), _vm._v("权限")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h2', [_vm._v("关联CCA单位信息，完成后可获得单位相关业务 "), _c('br'), _vm._v("权限")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h2', [_vm._v("关联CCA单位信息，完成后可获得单位相关业务 "), _c('br'), _vm._v("权限")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3bca9ac6","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/user/mine/info/MyInfo.vue
// module id = 2331
// module chunks = 0